
<div class="tanya">
    <div class="container">
        <div class="row text-center m-5">
            <div class="col-md-12">
                <h3>Our Best Open Trip Boats</h3>
                <p>Komodo National Park</p>
            </div>
        </div>


        <div class="row d-flex justify-content-center mb-3 mt-5">

          <!-- Tampilkan Pesan Jika Tidak Ada Boat -->
          <div *ngIf="kapalList.length === 0" class="col-12">
            <p class="text-muted text-center">No Boat Available</p>
          </div>
      
          <div class="col-md-4" *ngFor="let boat of kapalList">
            <div class="card mb-4 box-shadow">
              <div class="position-relative">
                <ng-container *ngIf="boat?.ms_gambarkapals && boat.ms_gambarkapals.length > 0">
                  <div class="position-absolute top-0 start-0 m-2 d-flex flex-column align-items-start gap-1" style="z-index: 10;">
                    <span class="badge bg-success" *ngIf="boat.featured">
                      FEATURED
                    </span>
                    <span *ngFor="let tag of boat.activity_tags" class="badge bg-info text-dark">
                      {{ tag | activityTagLabel }}
                    </span>
                  </div>
                  <span class="badge bg-secondary position-absolute top-0 end-0 m-2" style="z-index: 10;">
                    {{boat.boat_kategori}}
                  </span>
                </ng-container>
      
                <!-- Carousel -->
                <div 
                      [id]="'carouselExample-' + boat.id" 
                      class="carousel slide" 
                      (slid.bs.carousel)="onCarouselSlid($event, boat)"
                >
                 
                 <div class="carousel-inner" (click)="navigateToDetail(boat.slug)" style="cursor: pointer;">
                  <div 
                    class="carousel-item" 
                    *ngFor="let image of boat.ms_gambarkapals; let i = index" 
                    [ngClass]="{'active': i === 0}"
                  >
                    <img 
                      *ngIf="image.loaded" 
                      [src]="getImageUrl(image.gambar)"
                      class="d-block w-100" 
                      [alt]="boat.nama_kapal" 
                      loading="lazy" 
                    />
                  </div>
                </div>



                  <button *ngIf="boat?.ms_gambarkapals && boat.ms_gambarkapals.length > 1"  class="carousel-control-prev" type="button" [attr.data-bs-target]="'#carouselExample-' + boat.id" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button *ngIf="boat?.ms_gambarkapals && boat.ms_gambarkapals.length > 1" class="carousel-control-next" type="button" [attr.data-bs-target]="'#carouselExample-' + boat.id" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                  </button>
      
                  <div class="position-absolute bottom-0 start-0 p-3" *ngIf="boat?.ms_gambarkapals && boat.ms_gambarkapals.length > 0">
                    <h5 class="card-title text-white">       
                      <span class="hrg">IDR {{ boat.harga | number }}/Pax</span>
                    </h5>     
                  </div>
                </div>
              </div>
      
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center">
                  <h5 (click)="navigateToDetail(boat.slug)" class="card-subtitle" style="cursor: pointer;">{{ boat.nama_kapal }}</h5>
                </div>
      
                <div class="d-flex text-center mb-2">
                  <div class="ket me-3">
                    <i class="fa fa-calendar"></i> {{ boat.durasi }}
                  </div>
                  <div class="ket me-3">
                    <i class="fa fa-bed"></i> {{ boat.kabin }}
                  </div>
                  <div class="ket">
                    <i class="fa fa-users"></i> {{ boat.jumlah_tamu }}
                  </div>
                </div>
      
                <p class="mb-0 text-start">{{ boat.trip_kategori }}</p>
              </div>
            </div>
          </div>
      </div>
    </div>
</div>
